module.exports = __webpack_public_path__ + "static/media/bg_tripulacao.aca83129.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg/bg_tripulacao.png
// module id = 448
// module chunks = 0